import React from "react";
import { Fade } from "react-awesome-reveal";
import "../styles/Productos.scss";

const Productos = () => {
  const productos = [
    {
      id: 1,
      icono: "🎯",
      titulo: "Planes de Ahorro",
      texto:
        "Diseñados para alcanzar metas personales o familiares paso a paso, con disciplina y estrategia.",
    },
    {
      id: 2,
      icono: "🏦",
      titulo: "Planes de Ahorro para el Retiro",
      texto:
        "Asegura tu jubilación con beneficios fiscales y una estrategia a tu medida.",
    },
    {
      id: 3,
      icono: "❤️",
      titulo: "Seguros de Vida",
      texto:
        "Protege siempre a quienes más amas frente a imprevistos, cuidando su estabilidad y su futuro.",
    },
    {
      id: 4,
      icono: "🕊️",
      titulo: "Protección por Fallecimiento",
      texto:
        "Tranquilidad para ti y respaldo económico para tu familia cuando más lo necesiten.",
    },
    {
      id: 5,
      icono: "🛡️",
      titulo: "Protección por Invalidez",
      texto:
        "Garantiza tu estabilidad financiera en caso de pérdida de capacidad laboral.",
    },
    {
      id: 6,
      icono: "➕",
      titulo: "Coberturas Adicionales",
      texto:
        "Amplía tu protección con hospitalización, enfermedades graves plus o cirugías.",
    },
  ];

  return (
    <section className="productosContainer" id="productos">
      <Fade>
        <h4 className="fw-bold fs-3 titleProductos">💼 Nuestros productos</h4>
        <p className="subtitleProductos">
          En <strong>Asesorarte Seguros</strong> te ayudamos a construir un futuro financiero sólido y protegido.
          Nuestros agentes te acompañan paso a paso para elegir las mejores soluciones
          según tus metas y estilo de vida.
        </p>
      </Fade>

      <div className="gridProductos">
        {productos.map((p) => (
          <Fade key={p.id} duration={800}>
            <article className="cardProducto">
              <div className="iconProducto" aria-hidden="true">{p.icono}</div>
              <h5 className="tituloProducto">{p.titulo}</h5>
              <p className="textoProducto">{p.texto}</p>
            </article>
          </Fade>
        ))}
      </div>
    </section>
  );
};

export default Productos;
